import Button from "@mui/material/Button";
import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";

export const LeafButton = ({ title, style, ...props }) => {
  const { width } = useWindowSize();
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: "30px",
        padding: "15px 20px",
        backgroundColor: "var(--tree-leaf)",
        color: "#fff",
        width: width < 639 ? "60%" : "auto",
        fontSize: "18px",
        fontWeight: "semibold",
        textTransform: "none",
        whiteSpace: "nowrap",
        boxShadow: "0px 0px 0px 4.45px rgba(244, 168, 44, 0.40)",
        // boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",

        "&:hover": {
          backgroundColor: "#fff",
          color: "var(--tree-leaf)",
          boxShadow: "0px 0px 0px 4.45px rgba(244, 168, 44, 0.40)",
        },
        ...style,
      }}
      {...props}
    >
      {title}
    </Button>
  );
};
LeafButton.propTypes = {
  title: PropTypes.string,
  style: PropTypes.object,
};
